import { Branch } from '../types/Product';

// Comprehensive branches data - 150 branches across Uzbekistan
export const branchesData: Branch[] = [
  // TASHKENT - 30 branches
  {
    id: 'tash-001',
    name: 'EuropeGAS Tashkent Headquarters',
    address: '7 Bunyodkor Avenue',
    city: 'Tashkent',
    phone: '+998 71 200 0001',
    email: 'headquarters@europegas.uz',
    workingHours: { weekdays: '08:00 - 20:00', saturday: '09:00 - 18:00', sunday: '10:00 - 16:00' },
    coordinates: { lat: 41.311081, lng: 69.240562 }
  },
  {
    id: 'tash-002',
    name: 'EuropeGAS Chilanzar Central',
    address: '45 Chilanzar Street, 12th Block',
    city: 'Tashkent',
    phone: '+998 71 200 0002',
    email: 'chilanzar@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 41.275230, lng: 69.203850 }
  },
  {
    id: 'tash-003',
    name: 'EuropeGAS Yunusabad',
    address: '23 Amir Temur Avenue',
    city: 'Tashkent',
    phone: '+998 71 200 0003',
    email: 'yunusabad@europegas.uz',
    workingHours: { weekdays: '08:30 - 19:30', saturday: '09:00 - 18:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.338890, lng: 69.288890 }
  },
  {
    id: 'tash-004',
    name: 'EuropeGAS Sergeli',
    address: '78 Sergeli Highway',
    city: 'Tashkent',
    phone: '+998 71 200 0004',
    email: 'sergeli@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.229170, lng: 69.337500 }
  },
  {
    id: 'tash-005',
    name: 'EuropeGAS Mirzo Ulugbek',
    address: '156 Mirzo Ulugbek Street',
    city: 'Tashkent',
    phone: '+998 71 200 0005',
    email: 'ulugbek@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.334560, lng: 69.294430 }
  },
  {
    id: 'tash-006',
    name: 'EuropeGAS Shaykhantaur',
    address: '89 Shaykhantaur Street',
    city: 'Tashkent',
    phone: '+998 71 200 0006',
    email: 'shaykhantaur@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.296850, lng: 69.246540 }
  },
  {
    id: 'tash-007',
    name: 'EuropeGAS Yashnobod',
    address: '234 Yashnobod Street',
    city: 'Tashkent',
    phone: '+998 71 200 0007',
    email: 'yashnobod@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.285430, lng: 69.312560 }
  },
  {
    id: 'tash-008',
    name: 'EuropeGAS Almazar',
    address: '67 Almazar Street',
    city: 'Tashkent',
    phone: '+998 71 200 0008',
    email: 'almazar@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.345670, lng: 69.256780 }
  },
  {
    id: 'tash-009',
    name: 'EuropeGAS Bektemir',
    address: '123 Bektemir Highway',
    city: 'Tashkent',
    phone: '+998 71 200 0009',
    email: 'bektemir@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.207890, lng: 69.334560 }
  },
  {
    id: 'tash-010',
    name: 'EuropeGAS Uchtepa',
    address: '45 Uchtepa Street',
    city: 'Tashkent',
    phone: '+998 71 200 0010',
    email: 'uchtepa@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.256780, lng: 69.178900 }
  },
  {
    id: 'tash-011',
    name: 'EuropeGAS Mirobod',
    address: '78 Mirobod Street',
    city: 'Tashkent',
    phone: '+998 71 200 0011',
    email: 'mirobod@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.289560, lng: 69.267890 }
  },
  {
    id: 'tash-012',
    name: 'EuropeGAS Akmal Ikramov',
    address: '156 Akmal Ikramov Street',
    city: 'Tashkent',
    phone: '+998 71 200 0012',
    email: 'ikramov@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.323450, lng: 69.234560 }
  },
  {
    id: 'tash-013',
    name: 'EuropeGAS Hamid Alimjan',
    address: '234 Hamid Alimjan Street',
    city: 'Tashkent',
    phone: '+998 71 200 0013',
    email: 'alimjan@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 41.298760, lng: 69.289450 }
  },
  {
    id: 'tash-014',
    name: 'EuropeGAS Maksim Gorky',
    address: '89 Maksim Gorky Street',
    city: 'Tashkent',
    phone: '+998 71 200 0014',
    email: 'gorky@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.312340, lng: 69.256780 }
  },
  {
    id: 'tash-015',
    name: 'EuropeGAS Oybek',
    address: '67 Oybek Street',
    city: 'Tashkent',
    phone: '+998 71 200 0015',
    email: 'oybek@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 41.276540, lng: 69.298760 }
  },
  {
    id: 'tash-016',
    name: 'EuropeGAS Furkat',
    address: '123 Furkat Street',
    city: 'Tashkent',
    phone: '+998 71 200 0016',
    email: 'furkat@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.334560, lng: 69.245670 }
  },
  {
    id: 'tash-017',
    name: 'EuropeGAS Nukus',
    address: '45 Nukus Street',
    city: 'Tashkent',
    phone: '+998 71 200 0017',
    email: 'nukus-tash@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.287650, lng: 69.321450 }
  },
  {
    id: 'tash-018',
    name: 'EuropeGAS Labzak',
    address: '78 Labzak Street',
    city: 'Tashkent',
    phone: '+998 71 200 0018',
    email: 'labzak@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.298760, lng: 69.234560 }
  },
  {
    id: 'tash-019',
    name: 'EuropeGAS Chorsu',
    address: '156 Chorsu Bazaar Area',
    city: 'Tashkent',
    phone: '+998 71 200 0019',
    email: 'chorsu@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.326540, lng: 69.233450 }
  },
  {
    id: 'tash-020',
    name: 'EuropeGAS Sebzor',
    address: '234 Sebzor Street',
    city: 'Tashkent',
    phone: '+998 71 200 0020',
    email: 'sebzor@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.245670, lng: 69.287650 }
  },
  {
    id: 'tash-021',
    name: 'EuropeGAS Qoyliq',
    address: '89 Qoyliq Highway',
    city: 'Tashkent',
    phone: '+998 71 200 0021',
    email: 'qoyliq@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 41.376540, lng: 69.312340 }
  },
  {
    id: 'tash-022',
    name: 'EuropeGAS Qorasu',
    address: '67 Qorasu Street',
    city: 'Tashkent',
    phone: '+998 71 200 0022',
    email: 'qorasu@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.256780, lng: 69.345670 }
  },
  {
    id: 'tash-023',
    name: 'EuropeGAS Toshkent City',
    address: '123 Toshkent City Complex',
    city: 'Tashkent',
    phone: '+998 71 200 0023',
    email: 'city@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.312340, lng: 69.278900 }
  },
  {
    id: 'tash-024',
    name: 'EuropeGAS Kipchak',
    address: '45 Kipchak Street',
    city: 'Tashkent',
    phone: '+998 71 200 0024',
    email: 'kipchak@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.287650, lng: 69.198760 }
  },
  {
    id: 'tash-025',
    name: 'EuropeGAS Kuylyuk',
    address: '78 Kuylyuk Street',
    city: 'Tashkent',
    phone: '+998 71 200 0025',
    email: 'kuylyuk@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 41.323450, lng: 69.256780 }
  },
  {
    id: 'tash-026',
    name: 'EuropeGAS Sharaf Rashidov',
    address: '156 Sharaf Rashidov Avenue',
    city: 'Tashkent',
    phone: '+998 71 200 0026',
    email: 'rashidov@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.298760, lng: 69.321450 }
  },
  {
    id: 'tash-027',
    name: 'EuropeGAS Bodomzor',
    address: '234 Bodomzor Highway',
    city: 'Tashkent',
    phone: '+998 71 200 0027',
    email: 'bodomzor@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.334560, lng: 69.287650 }
  },
  {
    id: 'tash-028',
    name: 'EuropeGAS Risoviy Bazaar',
    address: '89 Risoviy Bazaar Area',
    city: 'Tashkent',
    phone: '+998 71 200 0028',
    email: 'risoviy@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.276540, lng: 69.234560 }
  },
  {
    id: 'tash-029',
    name: 'EuropeGAS Kunaev',
    address: '67 Kunaev Street',
    city: 'Tashkent',
    phone: '+998 71 200 0029',
    email: 'kunaev@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.312340, lng: 69.298760 }
  },
  {
    id: 'tash-030',
    name: 'EuropeGAS Minor',
    address: '123 Minor Street',
    city: 'Tashkent',
    phone: '+998 71 200 0030',
    email: 'minor@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.287650, lng: 69.312340 }
  },

  // GULISTAN - 30 branches
  {
    id: 'gul-001',
    name: 'EuropeGAS Gulistan Central',
    address: '45 Sharof Rashidov Street',
    city: 'Gulistan',
    phone: '+998 67 225 0001',
    email: 'gulistan-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4833, lng: 68.7833 }
  },
  {
    id: 'gul-002',
    name: 'EuropeGAS Gulistan North',
    address: '12 Mustaqillik Avenue',
    city: 'Gulistan',
    phone: '+998 67 225 0002',
    email: 'gulistan-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4950, lng: 68.7950 }
  },
  {
    id: 'gul-003',
    name: 'EuropeGAS Gulistan Industrial',
    address: '89 Factory District',
    city: 'Gulistan',
    phone: '+998 67 225 0003',
    email: 'gulistan-industrial@europegas.uz',
    workingHours: { weekdays: '08:00 - 17:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4720, lng: 68.7720 }
  },
  {
    id: 'gul-004',
    name: 'EuropeGAS Gulistan East',
    address: '67 Navoi Street',
    city: 'Gulistan',
    phone: '+998 67 225 0004',
    email: 'gulistan-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4890, lng: 68.7980 }
  },
  {
    id: 'gul-005',
    name: 'EuropeGAS Gulistan West',
    address: '123 Amir Temur Street',
    city: 'Gulistan',
    phone: '+998 67 225 0005',
    email: 'gulistan-west@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4780, lng: 68.7680 }
  },
  {
    id: 'gul-006',
    name: 'EuropeGAS Gulistan Market',
    address: '234 Central Market',
    city: 'Gulistan',
    phone: '+998 67 225 0006',
    email: 'gulistan-market@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4850, lng: 68.7820 }
  },
  {
    id: 'gul-007',
    name: 'EuropeGAS Gulistan South',
    address: '45 Buyuk Ipak Yuli',
    city: 'Gulistan',
    phone: '+998 67 225 0007',
    email: 'gulistan-south@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.4750, lng: 68.7850 }
  },
  {
    id: 'gul-008',
    name: 'EuropeGAS Gulistan University',
    address: '78 University Street',
    city: 'Gulistan',
    phone: '+998 67 225 0008',
    email: 'gulistan-university@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4920, lng: 68.7890 }
  },
  {
    id: 'gul-009',
    name: 'EuropeGAS Gulistan Stadium',
    address: '156 Stadium Area',
    city: 'Gulistan',
    phone: '+998 67 225 0009',
    email: 'gulistan-stadium@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 40.4860, lng: 68.7760 }
  },
  {
    id: 'gul-010',
    name: 'EuropeGAS Gulistan Park',
    address: '89 Park Avenue',
    city: 'Gulistan',
    phone: '+998 67 225 0010',
    email: 'gulistan-park@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4800, lng: 68.7900 }
  },
  {
    id: 'gul-011',
    name: 'EuropeGAS Gulistan Hospital',
    address: '67 Medical District',
    city: 'Gulistan',
    phone: '+998 67 225 0011',
    email: 'gulistan-hospital@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4880, lng: 68.7740 }
  },
  {
    id: 'gul-012',
    name: 'EuropeGAS Gulistan Station',
    address: '123 Railway Station',
    city: 'Gulistan',
    phone: '+998 67 225 0012',
    email: 'gulistan-station@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4770, lng: 68.7870 }
  },
  {
    id: 'gul-013',
    name: 'EuropeGAS Gulistan New City',
    address: '234 New District',
    city: 'Gulistan',
    phone: '+998 67 225 0013',
    email: 'gulistan-newcity@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 40.4910, lng: 68.7960 }
  },
  {
    id: 'gul-014',
    name: 'EuropeGAS Gulistan Airport',
    address: '45 Airport Road',
    city: 'Gulistan',
    phone: '+998 67 225 0014',
    email: 'gulistan-airport@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4700, lng: 68.7650 }
  },
  {
    id: 'gul-015',
    name: 'EuropeGAS Gulistan Mall',
    address: '78 Shopping Center',
    city: 'Gulistan',
    phone: '+998 67 225 0015',
    email: 'gulistan-mall@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 17:00', sunday: '10:00 - 16:00' },
    coordinates: { lat: 40.4840, lng: 68.7810 }
  },
  {
    id: 'gul-016',
    name: 'EuropeGAS Gulistan Tech',
    address: '156 Technology Park',
    city: 'Gulistan',
    phone: '+998 67 225 0016',
    email: 'gulistan-tech@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '10:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.4930, lng: 68.7940 }
  },
  {
    id: 'gul-017',
    name: 'EuropeGAS Gulistan Sports',
    address: '89 Sports Complex',
    city: 'Gulistan',
    phone: '+998 67 225 0017',
    email: 'gulistan-sports@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4790, lng: 68.7930 }
  },
  {
    id: 'gul-018',
    name: 'EuropeGAS Gulistan Culture',
    address: '67 Cultural Center',
    city: 'Gulistan',
    phone: '+998 67 225 0018',
    email: 'gulistan-culture@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4870, lng: 68.7780 }
  },
  {
    id: 'gul-019',
    name: 'EuropeGAS Gulistan Business',
    address: '123 Business District',
    city: 'Gulistan',
    phone: '+998 67 225 0019',
    email: 'gulistan-business@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4820, lng: 68.7860 }
  },
  {
    id: 'gul-020',
    name: 'EuropeGAS Gulistan Residential',
    address: '234 Residential Area',
    city: 'Gulistan',
    phone: '+998 67 225 0020',
    email: 'gulistan-residential@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4760, lng: 68.7920 }
  },
  {
    id: 'gul-021',
    name: 'EuropeGAS Gulistan Green',
    address: '45 Green Zone',
    city: 'Gulistan',
    phone: '+998 67 225 0021',
    email: 'gulistan-green@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.4900, lng: 68.7700 }
  },
  {
    id: 'gul-022',
    name: 'EuropeGAS Gulistan Center',
    address: '78 City Center',
    city: 'Gulistan',
    phone: '+998 67 225 0022',
    email: 'gulistan-center@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4830, lng: 68.7840 }
  },
  {
    id: 'gul-023',
    name: 'EuropeGAS Gulistan Metro',
    address: '156 Metro Station',
    city: 'Gulistan',
    phone: '+998 67 225 0023',
    email: 'gulistan-metro@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4810, lng: 68.7910 }
  },
  {
    id: 'gul-024',
    name: 'EuropeGAS Gulistan Plaza',
    address: '89 Central Plaza',
    city: 'Gulistan',
    phone: '+998 67 225 0024',
    email: 'gulistan-plaza@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4890, lng: 68.7750 }
  },
  {
    id: 'gul-025',
    name: 'EuropeGAS Gulistan Gateway',
    address: '67 Gateway Complex',
    city: 'Gulistan',
    phone: '+998 67 225 0025',
    email: 'gulistan-gateway@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 17:00', sunday: 'Closed' },
    coordinates: { lat: 40.4740, lng: 68.7880 }
  },
  {
    id: 'gul-026',
    name: 'EuropeGAS Gulistan Harbor',
    address: '123 Harbor Area',
    city: 'Gulistan',
    phone: '+998 67 225 0026',
    email: 'gulistan-harbor@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4950, lng: 68.7630 }
  },
  {
    id: 'gul-027',
    name: 'EuropeGAS Gulistan Valley',
    address: '234 Valley Road',
    city: 'Gulistan',
    phone: '+998 67 225 0027',
    email: 'gulistan-valley@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.4720, lng: 68.7950 }
  },
  {
    id: 'gul-028',
    name: 'EuropeGAS Gulistan Hills',
    address: '45 Hills District',
    city: 'Gulistan',
    phone: '+998 67 225 0028',
    email: 'gulistan-hills@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.4960, lng: 68.7850 }
  },
  {
    id: 'gul-029',
    name: 'EuropeGAS Gulistan Bridge',
    address: '78 Bridge Area',
    city: 'Gulistan',
    phone: '+998 67 225 0029',
    email: 'gulistan-bridge@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.4780, lng: 68.7720 }
  },
  {
    id: 'gul-030',
    name: 'EuropeGAS Gulistan Heritage',
    address: '156 Heritage Site',
    city: 'Gulistan',
    phone: '+998 67 225 0030',
    email: 'gulistan-heritage@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '10:00 - 17:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.4860, lng: 68.7800 }
  },

  // SAMARKAND - 15 branches
  {
    id: 'sam-001',
    name: 'EuropeGAS Samarkand Central',
    address: '22 Registan Square',
    city: 'Samarkand',
    phone: '+998 66 223 0001',
    email: 'samarkand-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.654388, lng: 66.975627 }
  },
  {
    id: 'sam-002',
    name: 'EuropeGAS Samarkand North',
    address: '156 Rudaki Avenue',
    city: 'Samarkand',
    phone: '+998 66 223 0002',
    email: 'samarkand-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.670000, lng: 66.980000 }
  },
  {
    id: 'sam-003',
    name: 'EuropeGAS Samarkand South',
    address: '78 Afrosiyob Street',
    city: 'Samarkand',
    phone: '+998 66 223 0003',
    email: 'samarkand-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.640000, lng: 66.970000 }
  },
  {
    id: 'sam-004',
    name: 'EuropeGAS Samarkand East',
    address: '89 Mirzo Ulugbek Street',
    city: 'Samarkand',
    phone: '+998 66 223 0004',
    email: 'samarkand-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.650000, lng: 66.990000 }
  },
  {
    id: 'sam-005',
    name: 'EuropeGAS Samarkand West',
    address: '234 Imam Bukhari Street',
    city: 'Samarkand',
    phone: '+998 66 223 0005',
    email: 'samarkand-west@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.655000, lng: 66.960000 }
  },
  {
    id: 'sam-006',
    name: 'EuropeGAS Samarkand University',
    address: '45 University Boulevard',
    city: 'Samarkand',
    phone: '+998 66 223 0006',
    email: 'samarkand-university@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 39.675000, lng: 66.985000 }
  },
  {
    id: 'sam-007',
    name: 'EuropeGAS Samarkand Market',
    address: '67 Siab Bazaar',
    city: 'Samarkand',
    phone: '+998 66 223 0007',
    email: 'samarkand-market@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 39.660000, lng: 66.975000 }
  },
  {
    id: 'sam-008',
    name: 'EuropeGAS Samarkand Airport',
    address: '123 Airport Road',
    city: 'Samarkand',
    phone: '+998 66 223 0008',
    email: 'samarkand-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.700000, lng: 66.950000 }
  },
  {
    id: 'sam-009',
    name: 'EuropeGAS Samarkand Station',
    address: '78 Railway Station',
    city: 'Samarkand',
    phone: '+998 66 223 0009',
    email: 'samarkand-station@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.645000, lng: 66.965000 }
  },
  {
    id: 'sam-010',
    name: 'EuropeGAS Samarkand Industrial',
    address: '156 Industrial Zone',
    city: 'Samarkand',
    phone: '+998 66 223 0010',
    email: 'samarkand-industrial@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 39.630000, lng: 66.955000 }
  },
  {
    id: 'sam-011',
    name: 'EuropeGAS Samarkand Mall',
    address: '89 Shopping Center',
    city: 'Samarkand',
    phone: '+998 66 223 0011',
    email: 'samarkand-mall@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 39.665000, lng: 66.980000 }
  },
  {
    id: 'sam-012',
    name: 'EuropeGAS Samarkand Park',
    address: '234 Central Park',
    city: 'Samarkand',
    phone: '+998 66 223 0012',
    email: 'samarkand-park@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.650000, lng: 66.985000 }
  },
  {
    id: 'sam-013',
    name: 'EuropeGAS Samarkand Heritage',
    address: '45 Heritage District',
    city: 'Samarkand',
    phone: '+998 66 223 0013',
    email: 'samarkand-heritage@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.655000, lng: 66.970000 }
  },
  {
    id: 'sam-014',
    name: 'EuropeGAS Samarkand Sports',
    address: '67 Sports Complex',
    city: 'Samarkand',
    phone: '+998 66 223 0014',
    email: 'samarkand-sports@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 39.672000, lng: 66.978000 }
  },
  {
    id: 'sam-015',
    name: 'EuropeGAS Samarkand Business',
    address: '123 Business District',
    city: 'Samarkand',
    phone: '+998 66 223 0015',
    email: 'samarkand-business@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 39.658000, lng: 66.982000 }
  },

  // BUKHARA - 10 branches
  {
    id: 'buk-001',
    name: 'EuropeGAS Bukhara Historic',
    address: '15 Lyabi Hauz',
    city: 'Bukhara',
    phone: '+998 65 224 0001',
    email: 'bukhara-historic@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 14:00', sunday: 'Closed' },
    coordinates: { lat: 39.767947, lng: 64.421701 }
  },
  {
    id: 'buk-002',
    name: 'EuropeGAS Bukhara North',
    address: '78 Navoi Street',
    city: 'Bukhara',
    phone: '+998 65 224 0002',
    email: 'bukhara-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.780000, lng: 64.430000 }
  },
  {
    id: 'buk-003',
    name: 'EuropeGAS Bukhara South',
    address: '156 Bakhtiyor Street',
    city: 'Bukhara',
    phone: '+998 65 224 0003',
    email: 'bukhara-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.750000, lng: 64.415000 }
  },
  {
    id: 'buk-004',
    name: 'EuropeGAS Bukhara East',
    address: '89 Mustaqillik Avenue',
    city: 'Bukhara',
    phone: '+998 65 224 0004',
    email: 'bukhara-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.770000, lng: 64.440000 }
  },
  {
    id: 'buk-005',
    name: 'EuropeGAS Bukhara West',
    address: '234 Khodja Nuriddina Street',
    city: 'Bukhara',
    phone: '+998 65 224 0005',
    email: 'bukhara-west@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.765000, lng: 64.400000 }
  },
  {
    id: 'buk-006',
    name: 'EuropeGAS Bukhara Airport',
    address: '45 Airport Road',
    city: 'Bukhara',
    phone: '+998 65 224 0006',
    email: 'bukhara-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 39.775000, lng: 64.483000 }
  },
  {
    id: 'buk-007',
    name: 'EuropeGAS Bukhara Market',
    address: '67 Central Bazaar',
    city: 'Bukhara',
    phone: '+998 65 224 0007',
    email: 'bukhara-market@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 39.772000, lng: 64.425000 }
  },
  {
    id: 'buk-008',
    name: 'EuropeGAS Bukhara University',
    address: '123 University Street',
    city: 'Bukhara',
    phone: '+998 65 224 0008',
    email: 'bukhara-university@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 39.760000, lng: 64.435000 }
  },
  {
    id: 'buk-009',
    name: 'EuropeGAS Bukhara Industrial',
    address: '78 Industrial Zone',
    city: 'Bukhara',
    phone: '+998 65 224 0009',
    email: 'bukhara-industrial@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 39.745000, lng: 64.450000 }
  },
  {
    id: 'buk-010',
    name: 'EuropeGAS Bukhara Station',
    address: '156 Railway Station',
    city: 'Bukhara',
    phone: '+998 65 224 0010',
    email: 'bukhara-station@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 39.755000, lng: 64.420000 }
  },

  // FERGANA - 10 branches
  {
    id: 'fer-001',
    name: 'EuropeGAS Fergana Central',
    address: '78 Al-Fergani Street',
    city: 'Fergana',
    phone: '+998 73 244 0001',
    email: 'fergana-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.3883, lng: 71.7833 }
  },
  {
    id: 'fer-002',
    name: 'EuropeGAS Fergana North',
    address: '156 Mustaqillik Street',
    city: 'Fergana',
    phone: '+998 73 244 0002',
    email: 'fergana-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.400000, lng: 71.790000 }
  },
  {
    id: 'fer-003',
    name: 'EuropeGAS Fergana South',
    address: '89 Navoi Avenue',
    city: 'Fergana',
    phone: '+998 73 244 0003',
    email: 'fergana-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.375000, lng: 71.780000 }
  },
  {
    id: 'fer-004',
    name: 'EuropeGAS Fergana East',
    address: '234 Amir Temur Street',
    city: 'Fergana',
    phone: '+998 73 244 0004',
    email: 'fergana-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.385000, lng: 71.800000 }
  },
  {
    id: 'fer-005',
    name: 'EuropeGAS Fergana West',
    address: '45 Istiqlol Street',
    city: 'Fergana',
    phone: '+998 73 244 0005',
    email: 'fergana-west@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.390000, lng: 71.765000 }
  },
  {
    id: 'fer-006',
    name: 'EuropeGAS Fergana Airport',
    address: '67 Airport Road',
    city: 'Fergana',
    phone: '+998 73 244 0006',
    email: 'fergana-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.370000, lng: 71.745000 }
  },
  {
    id: 'fer-007',
    name: 'EuropeGAS Fergana University',
    address: '123 University Boulevard',
    city: 'Fergana',
    phone: '+998 73 244 0007',
    email: 'fergana-university@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.395000, lng: 71.785000 }
  },
  {
    id: 'fer-008',
    name: 'EuropeGAS Fergana Market',
    address: '78 Central Market',
    city: 'Fergana',
    phone: '+998 73 244 0008',
    email: 'fergana-market@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.382000, lng: 71.788000 }
  },
  {
    id: 'fer-009',
    name: 'EuropeGAS Fergana Industrial',
    address: '156 Industrial Area',
    city: 'Fergana',
    phone: '+998 73 244 0009',
    email: 'fergana-industrial@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.365000, lng: 71.795000 }
  },
  {
    id: 'fer-010',
    name: 'EuropeGAS Fergana Sports',
    address: '89 Sports Complex',
    city: 'Fergana',
    phone: '+998 73 244 0010',
    email: 'fergana-sports@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.398000, lng: 71.775000 }
  },

  // ANDIJAN - 8 branches
  {
    id: 'and-001',
    name: 'EuropeGAS Andijan Central',
    address: '45 Babur Street',
    city: 'Andijan',
    phone: '+998 74 223 0001',
    email: 'andijan-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.783333, lng: 72.35 }
  },
  {
    id: 'and-002',
    name: 'EuropeGAS Andijan North',
    address: '123 Mustaqillik Avenue',
    city: 'Andijan',
    phone: '+998 74 223 0002',
    email: 'andijan-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.795000, lng: 72.360000 }
  },
  {
    id: 'and-003',
    name: 'EuropeGAS Andijan South',
    address: '78 Navoi Street',
    city: 'Andijan',
    phone: '+998 74 223 0003',
    email: 'andijan-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.770000, lng: 72.345000 }
  },
  {
    id: 'and-004',
    name: 'EuropeGAS Andijan East',
    address: '156 Alisher Navoi Street',
    city: 'Andijan',
    phone: '+998 74 223 0004',
    email: 'andijan-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.780000, lng: 72.370000 }
  },
  {
    id: 'and-005',
    name: 'EuropeGAS Andijan West',
    address: '89 Mashrab Street',
    city: 'Andijan',
    phone: '+998 74 223 0005',
    email: 'andijan-west@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.785000, lng: 72.330000 }
  },
  {
    id: 'and-006',
    name: 'EuropeGAS Andijan Airport',
    address: '234 Airport Highway',
    city: 'Andijan',
    phone: '+998 74 223 0006',
    email: 'andijan-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.730000, lng: 72.290000 }
  },
  {
    id: 'and-007',
    name: 'EuropeGAS Andijan University',
    address: '45 University Street',
    city: 'Andijan',
    phone: '+998 74 223 0007',
    email: 'andijan-university@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 40.790000, lng: 72.355000 }
  },
  {
    id: 'and-008',
    name: 'EuropeGAS Andijan Market',
    address: '67 Central Bazaar',
    city: 'Andijan',
    phone: '+998 74 223 0008',
    email: 'andijan-market@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.788000, lng: 72.348000 }
  },

  // NAMANGAN - 7 branches
  {
    id: 'nam-001',
    name: 'EuropeGAS Namangan Central',
    address: '12 Uychi Street',
    city: 'Namangan',
    phone: '+998 69 234 0001',
    email: 'namangan-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 14:00', sunday: 'Closed' },
    coordinates: { lat: 41.000085, lng: 71.672579 }
  },
  {
    id: 'nam-002',
    name: 'EuropeGAS Namangan North',
    address: '78 Mustaqillik Street',
    city: 'Namangan',
    phone: '+998 69 234 0002',
    email: 'namangan-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.015000, lng: 71.680000 }
  },
  {
    id: 'nam-003',
    name: 'EuropeGAS Namangan South',
    address: '156 Navoi Avenue',
    city: 'Namangan',
    phone: '+998 69 234 0003',
    email: 'namangan-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.985000, lng: 71.665000 }
  },
  {
    id: 'nam-004',
    name: 'EuropeGAS Namangan East',
    address: '89 Babur Street',
    city: 'Namangan',
    phone: '+998 69 234 0004',
    email: 'namangan-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.005000, lng: 71.690000 }
  },
  {
    id: 'nam-005',
    name: 'EuropeGAS Namangan West',
    address: '234 Alisher Navoi Street',
    city: 'Namangan',
    phone: '+998 69 234 0005',
    email: 'namangan-west@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.995000, lng: 71.650000 }
  },
  {
    id: 'nam-006',
    name: 'EuropeGAS Namangan Airport',
    address: '45 Airport Road',
    city: 'Namangan',
    phone: '+998 69 234 0006',
    email: 'namangan-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 41.020000, lng: 71.700000 }
  },
  {
    id: 'nam-007',
    name: 'EuropeGAS Namangan University',
    address: '67 University Boulevard',
    city: 'Namangan',
    phone: '+998 69 234 0007',
    email: 'namangan-university@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 16:00', sunday: 'Closed' },
    coordinates: { lat: 41.010000, lng: 71.675000 }
  },

  // NAVOI - 6 branches
  {
    id: 'nav-001',
    name: 'EuropeGAS Navoi Central',
    address: '34 Alisher Navoi Avenue',
    city: 'Navoi',
    phone: '+998 79 223 0001',
    email: 'navoi-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.0844, lng: 65.3792 }
  },
  {
    id: 'nav-002',
    name: 'EuropeGAS Navoi North',
    address: '123 Mustaqillik Street',
    city: 'Navoi',
    phone: '+998 79 223 0002',
    email: 'navoi-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.095000, lng: 65.385000 }
  },
  {
    id: 'nav-003',
    name: 'EuropeGAS Navoi South',
    address: '78 Kyzylkum Street',
    city: 'Navoi',
    phone: '+998 79 223 0003',
    email: 'navoi-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.070000, lng: 65.375000 }
  },
  {
    id: 'nav-004',
    name: 'EuropeGAS Navoi Industrial',
    address: '156 Mining Complex',
    city: 'Navoi',
    phone: '+998 79 223 0004',
    email: 'navoi-industrial@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.088000, lng: 65.390000 }
  },
  {
    id: 'nav-005',
    name: 'EuropeGAS Navoi Airport',
    address: '89 Airport Highway',
    city: 'Navoi',
    phone: '+998 79 223 0005',
    email: 'navoi-airport@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.117000, lng: 65.170000 }
  },
  {
    id: 'nav-006',
    name: 'EuropeGAS Navoi Station',
    address: '234 Railway Station',
    city: 'Navoi',
    phone: '+998 79 223 0006',
    email: 'navoi-station@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 40.080000, lng: 65.385000 }
  },

  // KARSHI - 6 branches
  {
    id: 'kar-001',
    name: 'EuropeGAS Karshi Central',
    address: '67 Mustaqillik Street',
    city: 'Karshi',
    phone: '+998 75 223 0001',
    email: 'karshi-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 38.8667, lng: 65.8 }
  },
  {
    id: 'kar-002',
    name: 'EuropeGAS Karshi North',
    address: '123 Navoi Avenue',
    city: 'Karshi',
    phone: '+998 75 223 0002',
    email: 'karshi-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 38.880000, lng: 65.810000 }
  },
  {
    id: 'kar-003',
    name: 'EuropeGAS Karshi South',
    address: '78 Amir Temur Street',
    city: 'Karshi',
    phone: '+998 75 223 0003',
    email: 'karshi-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 38.850000, lng: 65.795000 }
  },
  {
    id: 'kar-004',
    name: 'EuropeGAS Karshi East',
    address: '156 Bukhara Highway',
    city: 'Karshi',
    phone: '+998 75 223 0004',
    email: 'karshi-east@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 38.870000, lng: 65.820000 }
  },
  {
    id: 'kar-005',
    name: 'EuropeGAS Karshi University',
    address: '89 University Street',
    city: 'Karshi',
    phone: '+998 75 223 0005',
    email: 'karshi-university@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 38.875000, lng: 65.805000 }
  },
  {
    id: 'kar-006',
    name: 'EuropeGAS Karshi Airport',
    address: '234 Airport Road',
    city: 'Karshi',
    phone: '+998 75 223 0006',
    email: 'karshi-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 17:00', sunday: '10:00 - 15:00' },
    coordinates: { lat: 38.835000, lng: 65.775000 }
  },

  // TERMEZ - 5 branches
  {
    id: 'ter-001',
    name: 'EuropeGAS Termez Central',
    address: '12 Amir Temur Street',
    city: 'Termez',
    phone: '+998 76 223 0001',
    email: 'termez-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 14:00', sunday: 'Closed' },
    coordinates: { lat: 37.2333, lng: 67.2667 }
  },
  {
    id: 'ter-002',
    name: 'EuropeGAS Termez North',
    address: '78 Mustaqillik Avenue',
    city: 'Termez',
    phone: '+998 76 223 0002',
    email: 'termez-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 37.245000, lng: 67.275000 }
  },
  {
    id: 'ter-003',
    name: 'EuropeGAS Termez Port',
    address: '156 Port Area',
    city: 'Termez',
    phone: '+998 76 223 0003',
    email: 'termez-port@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 37.220000, lng: 67.255000 }
  },
  {
    id: 'ter-004',
    name: 'EuropeGAS Termez Airport',
    address: '89 Airport Highway',
    city: 'Termez',
    phone: '+998 76 223 0004',
    email: 'termez-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 37.286000, lng: 67.308000 }
  },
  {
    id: 'ter-005',
    name: 'EuropeGAS Termez University',
    address: '234 University Boulevard',
    city: 'Termez',
    phone: '+998 76 223 0005',
    email: 'termez-university@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 37.240000, lng: 67.270000 }
  },

  // JIZZAKH - 5 branches
  {
    id: 'jiz-001',
    name: 'EuropeGAS Jizzakh Central',
    address: '23 Sharof Rashidov Avenue',
    city: 'Jizzakh',
    phone: '+998 72 226 0001',
    email: 'jizzakh-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.1167, lng: 67.85 }
  },
  {
    id: 'jiz-002',
    name: 'EuropeGAS Jizzakh North',
    address: '78 Mustaqillik Street',
    city: 'Jizzakh',
    phone: '+998 72 226 0002',
    email: 'jizzakh-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.130000, lng: 67.860000 }
  },
  {
    id: 'jiz-003',
    name: 'EuropeGAS Jizzakh South',
    address: '156 Navoi Avenue',
    city: 'Jizzakh',
    phone: '+998 72 226 0003',
    email: 'jizzakh-south@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.100000, lng: 67.845000 }
  },
  {
    id: 'jiz-004',
    name: 'EuropeGAS Jizzakh Industrial',
    address: '89 Industrial Zone',
    city: 'Jizzakh',
    phone: '+998 72 226 0004',
    email: 'jizzakh-industrial@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 40.125000, lng: 67.870000 }
  },
  {
    id: 'jiz-005',
    name: 'EuropeGAS Jizzakh University',
    address: '234 University Street',
    city: 'Jizzakh',
    phone: '+998 72 226 0005',
    email: 'jizzakh-university@europegas.uz',
    workingHours: { weekdays: '08:00 - 18:00', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 40.120000, lng: 67.855000 }
  },

  // NUKUS - 4 branches
  {
    id: 'nuk-001',
    name: 'EuropeGAS Nukus Central',
    address: '23 Beruni Street',
    city: 'Nukus',
    phone: '+998 61 222 0001',
    email: 'nukus-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 14:00', sunday: 'Closed' },
    coordinates: { lat: 42.4628, lng: 59.6166 }
  },
  {
    id: 'nuk-002',
    name: 'EuropeGAS Nukus North',
    address: '78 Mustaqillik Avenue',
    city: 'Nukus',
    phone: '+998 61 222 0002',
    email: 'nukus-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 42.475000, lng: 59.625000 }
  },
  {
    id: 'nuk-003',
    name: 'EuropeGAS Nukus University',
    address: '156 University Boulevard',
    city: 'Nukus',
    phone: '+998 61 222 0003',
    email: 'nukus-university@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 42.470000, lng: 59.620000 }
  },
  {
    id: 'nuk-004',
    name: 'EuropeGAS Nukus Airport',
    address: '89 Airport Road',
    city: 'Nukus',
    phone: '+998 61 222 0004',
    email: 'nukus-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 42.480000, lng: 59.650000 }
  },

  // URGENCH - 4 branches
  {
    id: 'urg-001',
    name: 'EuropeGAS Urgench Central',
    address: '56 Al-Khorezmi Street',
    city: 'Urgench',
    phone: '+998 62 226 0001',
    email: 'urgench-central@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 14:00', sunday: 'Closed' },
    coordinates: { lat: 41.55, lng: 60.6333 }
  },
  {
    id: 'urg-002',
    name: 'EuropeGAS Urgench North',
    address: '123 Mustaqillik Street',
    city: 'Urgench',
    phone: '+998 62 226 0002',
    email: 'urgench-north@europegas.uz',
    workingHours: { weekdays: '09:00 - 19:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.560000, lng: 60.640000 }
  },
  {
    id: 'urg-003',
    name: 'EuropeGAS Urgench University',
    address: '78 University Avenue',
    city: 'Urgench',
    phone: '+998 62 226 0003',
    email: 'urgench-university@europegas.uz',
    workingHours: { weekdays: '08:30 - 18:30', saturday: '09:00 - 15:00', sunday: 'Closed' },
    coordinates: { lat: 41.555000, lng: 60.635000 }
  },
  {
    id: 'urg-004',
    name: 'EuropeGAS Urgench Airport',
    address: '156 Airport Highway',
    city: 'Urgench',
    phone: '+998 62 226 0004',
    email: 'urgench-airport@europegas.uz',
    workingHours: { weekdays: '09:00 - 18:00', saturday: '10:00 - 16:00', sunday: '10:00 - 14:00' },
    coordinates: { lat: 41.584000, lng: 60.641000 }
  }
];

// Helper function to get branches by city
export const getBranchesByCity = (city: string): Branch[] => {
  if (city === 'all') return branchesData;
  return branchesData.filter(branch => branch.city === city);
};

// Helper function to get branch count by city
export const getBranchCountByCity = (): Record<string, number> => {
  const counts: Record<string, number> = {};
  branchesData.forEach(branch => {
    counts[branch.city] = (counts[branch.city] || 0) + 1;
  });
  return counts;
};

// Cities with coordinates for map navigation
export const citiesWithCoordinates = [
  { name: 'all', displayName: 'All Cities', coordinates: { lat: 41.311081, lng: 69.240562 } },
  { name: 'Tashkent', displayName: 'Tashkent (30)', coordinates: { lat: 41.311081, lng: 69.240562 } },
  { name: 'Gulistan', displayName: 'Gulistan (30)', coordinates: { lat: 40.4833, lng: 68.7833 } },
  { name: 'Samarkand', displayName: 'Samarkand (15)', coordinates: { lat: 39.654388, lng: 66.975627 } },
  { name: 'Bukhara', displayName: 'Bukhara (10)', coordinates: { lat: 39.767947, lng: 64.421701 } },
  { name: 'Fergana', displayName: 'Fergana (10)', coordinates: { lat: 40.3883, lng: 71.7833 } },
  { name: 'Andijan', displayName: 'Andijan (8)', coordinates: { lat: 40.783333, lng: 72.35 } },
  { name: 'Namangan', displayName: 'Namangan (7)', coordinates: { lat: 41.000085, lng: 71.672579 } },
  { name: 'Navoi', displayName: 'Navoi (6)', coordinates: { lat: 40.0844, lng: 65.3792 } },
  { name: 'Karshi', displayName: 'Karshi (6)', coordinates: { lat: 38.8667, lng: 65.8 } },
  { name: 'Termez', displayName: 'Termez (5)', coordinates: { lat: 37.2333, lng: 67.2667 } },
  { name: 'Jizzakh', displayName: 'Jizzakh (5)', coordinates: { lat: 40.1167, lng: 67.85 } },
  { name: 'Nukus', displayName: 'Nukus (4)', coordinates: { lat: 42.4628, lng: 59.6166 } },
  { name: 'Urgench', displayName: 'Urgench (4)', coordinates: { lat: 41.55, lng: 60.6333 } }
];
